<template>
  <section>
  <div v-if="loading">
    <!-- Title -->
    <div class="intro-y flex flex-col-reverse mt-3 sm:flex-row items-center" v-if="current.accounts.length">
      <h2 class="intro-y text-lg font-medium mr-auto mt-2">
          Cuentas Asignadas ({{ current.accounts.length }})
      </h2>
    </div>
    <!-- END: Title -->

        <!-- List -->
    <div class="grid grid-cols-12 gap-3 mt-5">
      <div class="intro-y col-span-12 md:col-span-3" v-for="(account, index) in current.accounts" :key="index">
        <div class="box bg-theme-1 text-white">
          <div class="flex flex-col lg:flex-row items-center p-5 border-b border-gray-200">
              <div class="lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0">
                  <a href="#" class="font-medium">{{account.name}} - {{account.country.prefix}}</a>
              </div>
              <div class="flex -ml-2 lg:ml-0 lg:justify-end mt-3 lg:mt-0">
                  <a v-on:click="removeAccount(account)" class="pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 zoom-in text-white">
                    <app-icon name="minus" classname="w-4 h-4 mr-2"></app-icon>
                  </a>
              </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END: List -->

    <!-- Title -->
    <div class="intro-y flex flex-col-reverse mt-3 sm:flex-row items-center" v-if="filteredAccounts.length">
      <h2 class="intro-y text-lg font-medium mr-auto mt-2">
          Cuentas Sin Asignar ({{ filteredAccounts.length }})
      </h2>
    </div>
    <!-- END: Title -->

        <!-- List -->
    <div class="grid grid-cols-12 gap-3 mt-5">
      <div class="intro-y col-span-12 md:col-span-3" v-for="(account, index) in filteredAccounts" :key="index">
        <div class="box">
          <div class="flex flex-col lg:flex-row items-center p-5 border-b border-gray-200">
              <div class="lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0">
                  <a href="#" class="font-medium">{{account.name}} - {{account.country.prefix}}</a>
              </div>
              <div class="flex -ml-2 lg:ml-0 lg:justify-end mt-3 lg:mt-0">
                  <a v-on:click="addAccount(account)" class="pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in">
                    <app-icon name="plus" classname="w-4 h-4 mr-2"></app-icon>
                  </a>
              </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END: List -->
  </div>
  <div v-else>
    <app-loading></app-loading>
  </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Loading from '@/components/admin/partials/LoadingWhite'

export default {
  name: 'AssignAccountUser',
  data () {
    return {
      loading: false,
      boxedit: false,
      view: {
        entity: 'user',
        id: this.$route.params.id
      },
    }
  },
  computed: {
    ...mapGetters({
      accounts: 'getAccounts',
      account: 'getAccount',
      current: 'getCurrentUser',
    }),
    filteredAccounts() {
      return this.accounts.filter((account) => {
        if (!this.current.accounts.some(item => item.id == account.id)) {
          return account
        }
      })
    }
  },
  async beforeMount () {
    //SEND ENTITY AND MUTATION
    await Promise.all([
        this.getList('account'),
        this.lookCurrentUser(),
    ]);

    this.loading = true
  },
  methods: {
    addAccount(account) {
      let form = {
        entity: 'accountuser',
        id: this.current.id,
        account_id: account.id,
      }

      this.store(form)
        .then(() => {
          this.lookCurrentUser()
        })
    },
    removeAccount(account) {
      let form = {
        entity: 'accountuser',
        id: this.current.id,
        account_id: account.id,
      }

      this.update(form)
        .then(() => {
          this.lookCurrentUser()
        })
    },
    lookCurrentUser() {
      this.show(this.view)
        .then(response => {
          this.loading = true
        })
    },
    updateValue (attribute, e) {
      this.user_current[attribute] = e.target.value
    },
    ...mapActions([
      'show',
      'getAll',
      'getList',
      'store',
      'update',
      'remove'
    ])
  },
  components: {
    appIcon: Icon,
    appLoading: Loading
  }
}
</script>



// WEBPACK FOOTER //
// AccountUser.vue?27d4618e